import Css from "./style.module.scss";

import DocumentPreview from "nlib/common/DocumentPreview";
import DocumentRecogniseStatuses from "const/DocumentRecogniseStatuses";
import React from "react";

const PreviewCell = ({ documentData }) => {
  const { recogniseData: { status: recogniseStatus, previewFile }, attachment } = documentData;

  return (
    <div className={Css.previewCell}>
      <DocumentPreview
        className={Css.documentPreview}
        error={recogniseStatus === DocumentRecogniseStatuses.ERROR}
        hasAttachment={!!attachment.key}
        documentPreview={previewFile} />
    </div>
  );
};

export default React.memo(PreviewCell);
